import React, { useEffect, useState } from "react";
import axios from "../axios";

export default function PostContributePage() {
  const [data, setData] = useState([]);
  const [range, setRange] = useState("today"); // today, yesterday, two_days_ago, 7days, 30days
  const [loading, setLoading] = useState(false);

  const ranges = [
    { key: "today", label: "本日" },
    { key: "yesterday", label: "昨日" },
    { key: "two_days_ago", label: "一昨日" },
    { key: "7days", label: "直近7日間" },
    { key: "30days", label: "直近30日間" },
  ];

  const fetchData = () => {
    setLoading(true);
    axios
      .get(`/post-contribute?range=${range}`)
      .then(res => setData(res.data.result))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, [range]);

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "16px",
        background: "linear-gradient(180deg, #ecfdf5 0%, #f0fdf4 100%)",
        fontFamily: "sans-serif",
      }}
    >
      <h2 style={{ textAlign: "center", color: "#047857", marginBottom: "24px" }}>
        投稿貢献度ランキング
      </h2>

      {/* 期間切替 */}
      <div style={{ textAlign: "center", marginBottom: "24px" }}>
        {ranges.map(r => (
          <button
            key={r.key}
            onClick={() => setRange(r.key)}
            style={{
              margin: "0 3px",
              padding: "6px 6px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontWeight: "600",
              backgroundColor: range === r.key ? "#34d399" : "#a7f3d0",
              color: range === r.key ? "#fff" : "#047857",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = 0.8}
            onMouseLeave={e => e.currentTarget.style.opacity = 1}
          >
            {r.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: "center", color: "#065f46" }}>読み込み中...</div>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            backgroundColor: "#a7f3d0",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#34d399", color: "#fff" }}>
              <th style={{ padding: "8px" }}>順位</th>
              <th style={{ padding: "8px" }}>ユーザー</th>
              <th style={{ padding: "8px" }}>投稿数</th>
              <th style={{ padding: "8px" }}>割合</th>
              <th style={{ padding: "8px" }}>グラフ</th>
            </tr>
          </thead>
          <tbody>
            {data.map((d, idx) => (
              <tr key={d.user_id} style={{ borderBottom: "1px solid #047857" }}>
                <td style={{ padding: "8px", textAlign: "center", fontWeight: "600" }}>{idx + 1}</td>
                <td style={{ padding: "8px" }}>{d.user_name}</td>
                <td style={{ padding: "8px", textAlign: "center" }}>{d.count}</td>
                <td style={{ padding: "8px", textAlign: "center" }}>{d.percent}%</td>
                <td style={{ padding: "8px" }}>
                  <div
                    style={{
                      height: "12px",
                      backgroundColor: "#047857",
                      width: `${d.percent}%`,
                      borderRadius: "6px",
                      transition: "width 0.5s ease",
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
